// import React, { Component } from 'react'
// import { Card, Col, Row, Table } from "react-bootstrap-v5";
// import 'react-bootstrap-typeahead/css/Typeahead.css';
// import moment from "moment";
// import { MdEdit} from "react-icons/md"

// import JobService from "../../Services/JobService";
// import { revenuecostService } from '../../Services/revenuecostService'
// import { useLocation } from 'react-router-dom'

// class InvoiceList extends Component {
//     state = {
//         jobList: [],
//          location : useLocation(),
//      user_type : localStorage.getItem("user_type")
//     }

//     // const location = useLocation()
//     // let user_type = localStorage.getItem("user_type")

//     componentDidMount() {
//         this.getJobList()
//         this.signInIntuit()
//     }

//     getJobList = () => {
//         let param = {};
//         param["limit"] = 1000;
//         param["page"] = 1;

//         JobService.getPayInvoiceJob(param).then(result => {
//             if (result.status === true) {
//                 this.setState({ jobList: result.data })
//             }
//         })
//     }

//     signInIntuit = () => {
//         // var win;
//         // var parameters = "location=1,width=800,height=650";
//         // parameters += ",left=" + (window.innerWidth - 800) / 2 + ",top=" + (window.innerHeight - 650) / 2;

//         revenuecostService.qbookAuth().then(result => {
//             // Launch Popup
//             // win = window.open(result, 'connectPopup', parameters);
//             // this.props.history.push(result)
//             if(!result.status){
//                 localStorage.setItem('redirectUri', window.location.href)
//                 window.location.href = result.uri
//             }

//         })

//     }

//     render() {

//         const { jobList } = this.state

//         return (
//             <Card>
//                 <Card.Body>
//                 <Row>
//                     <Col>
//                         <Table striped bordered hover>
//                             <thead>
//                                 <tr>
//                                     <th>S.No</th>
//                                     <th>Job Id</th>
//                                     <th>Customer Name</th>
//                                     <th>Amount</th>
//                                     <th>Date</th>
//                                     <th>#</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {
//                                     jobList.map((item, index)=> {
//                                         return (
//                                             <tr>
//                                                 <td>{index + 1}</td>
//                                                 <td>{item.jobToken}</td>
//                                                 <td>{item.custName}</td>
//                                                 <td>{item.amount}</td>
//                                                 <td>{moment(item.dateAt).format("YYYY-MM-DD")}</td>
//                                                 <td>
//                                                     {
//                                                         (/edit/.test(this.state.location.search)) ||  this.state.user_type === "SUPERADMIN" &&
//                                                     <MdEdit
//                                                         className="pointer"
//                                                         onClick={() => this.props.history.push(`invoice-by-job?id=${item._id}`)}
//                                                         color="#0323fe"
//                                                         size="25px"
//                                                     />
//                                                     }
//                                                 </td>
//                                             </tr>
//                                         )
//                                     })
//                                 }

//                             </tbody>
//                         </Table>
//                     </Col>
//                 </Row>
//                 </Card.Body>
//             </Card>
//         )
//     }
// }

// export { InvoiceList }

import React, { Component } from "react";
import { Card, Col, Form, Row, Table } from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import { MdEdit } from "react-icons/md";
import { withRouter } from "react-router-dom";
import JobService from "../../Services/JobService";
import { revenuecostService } from "../../Services/revenuecostService";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
import CheckAccess from "../../Function/CheckAccess";
import { toast } from "react-toastify";
import Select from "react-select";

let currentPage1 = 1;

const ProviderOption = [
  { value: undefined, label: "All" },
  { value: "fullypaid", label: "PAID" },
  { value: "unpaid", label: "UNPAID" },
];
class InvoiceList extends Component {
  state = {
    jobList: [],
    user_type: localStorage.getItem("user_type"),
    loader: true,
    pagination: { page: 1, limit: 10, totalRecord: 0 },
    currentPage: currentPage1,
  };

  componentDidMount() {
    this.getJobList();
    this.signInIntuit();
  }

  getJobList = (param = {}) => {
    const { pagination, currentPage } = this.state;
    param = {
      ...param,
      limit: pagination.limit,
      page: currentPage,
    };

    const filteredParam = Object.fromEntries(
      Object.entries(param).filter(([_, value]) => value !== undefined)
    );

    // if(val){
    //   param["search"] = val.searchText
    // }

    JobService.getPayInvoiceJob(filteredParam).then((result) => {
      if (result.status === true) {
        this.setState({
          jobList: result.data,
          pagination: {
            ...pagination,
            totalRecord: result.pagination.totalRecord,
          },
          loader: false,
        });
      } else {
        this.setState({ loader: false });
      }
    });
  };

  signInIntuit = () => {
    revenuecostService.qbookAuth().then((result) => {
      if (!result.status) {
        localStorage.setItem("redirectUri", window.location.href);
        window.location.href = result.uri;
      }
    });
  };

  onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1;
    this.setState({ loader: true, currentPage: e.selected + 1 }, () => {
      this.getJobList();
    });
  };

  handleSearch = (e) => {
    const { value } = e.target;
    this.setState({ search: value }, () => {
      let search = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        paymentStatus: this.state.paymentStatus,
        search: value,
      };
      this.getJobList(search);
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    let setdate = name === "start_date" ? "startDate" : "endDate";

    const selectedDate = new Date(value).getTime();
    this.setState({ [setdate]: selectedDate }, () => {
      const { startDate, endDate } = this.state;

      if (startDate !== "" && endDate !== "") {
        if (startDate > endDate) {
          this.setState({ startDate: "", endDate: "" });
          toast.info("Start date cannot be greater than end date.");
        } else {
          let search = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            search: this.state.search,
            paymentStatus: this.state.paymentStatus,
          };
          this.getJobList(search);
        }
      }
    });
  };

  handleFilter = (e) => {
    const  value = e.value;
    this.setState({ paymentStatus: value }, () => {
      let search = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        search: this.state.search,
        paymentStatus: value,
      };
      this.getJobList(search);
    });
  }



  render() {
    const { jobList, user_type, loader, pagination, currentPage } = this.state;
    const { location, history } = this.props;

    return (
      <Card>
        <Card.Body>
          <Row>
            <Col sm={3} className="mb-3">
              <Form.Label>Search</Form.Label>
              <Form.Control
                type="text"
                name="search_text"
                placeholder="Sales Person"
                onChange={(e) => this.handleSearch(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                // max={new Date().toISOString().split('T')[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                // max={new Date().toISOString().split('T')[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>Select Payment Status</Form.Label>
              <Select
                styles={{
                  valueContainer: (provided) => ({
                    ...provided,
                    // height: "calc(2.15rem + 2px)",
                    overflowY: "visible",
                    height: "2.1rem",  // Adjusted height for minimal appearance
                    padding: "0 8px",
                  }),
                  control: (provider) => ({
                    ...provider,
                    minHeight: "2.1rem",
                    height: "2.1rem",
                    boxShadow: "0 0 0 0px #f46a6a",
                  }),
                  placeholder: (provider) => ({
                    ...provider,
                    color: "#a0b0ca",
                  }),
                }}
                // value={destinationCountryValue}
                onChange={(e) => this.handleFilter(e)}
                placeholder="Payment Status"
                options={ProviderOption}
              />
            </Col>
            <Col sm={12}>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Job Id</th>
                    <th>Customer Name</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  {jobList.map((item, index) => (
                    <tr key={index}>
                      {/* <td>{index + 1}</td> */}
                      <td className="text-body fw-bold">
                        {(currentPage - 1) * pagination.limit + (index + 1)}
                      </td>
                      <td>{item.jobToken}</td>
                      <td>{item.custName}</td>
                      <td>{item.amount}</td>
                      <td>{moment(item.dateAt).format("YYYY-MM-DD")}</td>
                      <td>
                        {(CheckAccess(422, "edit") ||
                          user_type === "SUPERADMIN") && (
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push(`invoice-by-job?id=${item._id}`)
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {jobList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="prev"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="next"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={this.onPageChangeEvent}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
              <Loader isShow={loader} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { InvoiceList };
